/*
 * transfer 穿梭框
 * author zhousheng
 */
import * as React from 'react';
import classnames from 'classnames';
import { ConfigContext } from '../config-provider';
import { useLocaleReceiver } from '../locale-provider/LocaleReceiver';
import DataSource from './DataSource';
import Target from './Target';
const Transfer = (props) => {
    const { prefixCls: customizePrefixCls, className, displayType = 'single', targetKeys, onChange, locale = {}, dataSource, columns, leftColumns, rightColumns, leftPagination, rightPagination, targetDataSelf, targetData: outTargetData = [], onTargetDataChange, dataSourceCustom, labelRender } = props;
    const [transferLocale] = useLocaleReceiver('Transfer');
    const userLocale = Object.assign(Object.assign({}, transferLocale), locale);
    const [loading, setLoading] = React.useState(false);
    const [tKeys, setTKeys] = React.useState(targetKeys || []);
    const mergedKeys = 'targetKeys' in props ? targetKeys : tKeys;
    // targetData
    const [targetData, setTargetData] = React.useState(outTargetData);
    const mergedTargetData = 'targetData' in props ? outTargetData : targetData;
    // table左右两侧columns 配置
    const innerLeftColumns = leftColumns || columns;
    const innerRightColumns = rightColumns || columns;
    // table左右两侧pagination 配置
    const innerLeftPagination = leftPagination;
    const innerRightPagination = rightPagination;
    // 是否是初始化执行
    const isInit = React.useRef(true);
    // 二级数据展开成一级数据
    const expansionSource = React.useMemo(() => {
        const expansionArr = [];
        dataSource.forEach(data => {
            if (!data.children || !data.children.length) {
                expansionArr.push(data);
                return;
            }
            const childrenKeys = [];
            expansionArr.push(Object.assign(Object.assign({}, data), { childrenKeys, group: true, disabled: data.disabled || data.children.every(child => child.disabled) }));
            data.children.forEach(child => {
                expansionArr.push(Object.assign(Object.assign({}, child), { groupKey: data.key, groupOption: true, disabled: data.disabled || child.disabled }));
                childrenKeys.push(child.key);
            });
        });
        return expansionArr;
    }, [dataSource]);
    React.useEffect(() => {
        if (isInit.current) {
            isInit.current = false;
            // 初始化不触发onChange
            return;
        }
        changeTargetData(tKeys);
        onChange && onChange(tKeys);
    }, [tKeys]);
    const changeTargetData = React.useCallback((tKeys) => {
        // 如果左右数据分离，需要遍历key，从左侧数据找到完整的data
        if (targetDataSelf && displayType === 'table') {
            // 如果tKeys为空，说明清空了已选项，需要清空targetData
            // 不直接赋予空值的话一次性清空右侧数据时，targetData会剩一半数据
            const tempTargetData = (tKeys === null || tKeys === void 0 ? void 0 : tKeys.length) === 0 ? [] : [...mergedTargetData];
            tKeys.forEach(tk => {
                const sourceItem = expansionSource.find(s => s.key === tk);
                if (sourceItem) {
                    // 还需要看当前targetdata里存不存在
                    const targetItem = mergedTargetData.find(td => td.key === tk);
                    if (!targetItem) {
                        tempTargetData.push(sourceItem);
                    }
                }
            });
            // 移除tempTargetData中不存在于tKeys的数据
            tempTargetData.forEach(td => {
                if (!tKeys.includes(td.key)) {
                    const index = tempTargetData.findIndex(t => t.key === td.key);
                    index !== -1 && tempTargetData.splice(index, 1);
                }
            });
            setTargetData(tempTargetData);
            onTargetDataChange === null || onTargetDataChange === void 0 ? void 0 : onTargetDataChange(tempTargetData);
        }
    }, [targetDataSelf, displayType, expansionSource, mergedTargetData]);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('transfer', customizePrefixCls);
    const classNames = classnames({
        [prefixCls]: true,
        [className]: className,
        [`${prefixCls}-table`]: displayType === 'table'
    });
    const rightExpansionSource = targetDataSelf && displayType === 'table' ? mergedTargetData : expansionSource;
    return (<div className={classNames}>
            <DataSource {...props} displayType={displayType} locale={userLocale} prefixCls={prefixCls} tKeys={mergedKeys} setTKeys={setTKeys} loading={loading} setLoading={setLoading} expansionSource={expansionSource} columns={innerLeftColumns} pagination={innerLeftPagination} labelRender={labelRender}/>
            <Target {...props} displayType={displayType} locale={userLocale} prefixCls={prefixCls} tKeys={mergedKeys} setTKeys={setTKeys} loading={loading} setLoading={setLoading} expansionSource={typeof dataSourceCustom === 'function' ? dataSourceCustom(rightExpansionSource) : rightExpansionSource} columns={innerRightColumns} pagination={innerRightPagination}/>
        </div>);
};
export default Transfer;
